import React from "react";

export default function QuickStatsBox(props) {
  return (
    <div className="col-xl col-12 p-0 single-quick-stat-box d-flex justify-content-between align-items-center">
      {/* Details */}
      <div className="details-side">
        <h2 className="fw-semibold mb-0">{props.totalNumber}</h2>
        <p className="m-0">{props.boxTitle}</p>
      </div>
      {/* Icon */}
      <div className="icon-side">
        <img src={props.icon} alt="count" style={{width : props.w ? props.w : "32px"}} />
      </div>
    </div>
  );
}
